import { createContext } from "react";

const FlippingContext = createContext();

export default FlippingContext;